























































import Vue from 'vue';
import layout from '@/libs/layout/school/teacher'
import { Component } from 'vue-property-decorator';
import { TTeacherPage, SchoolState, PTeacherList } from '@/types/views/school';
import { TLayout } from '@/types/utils';
import { getTeacherList } from '@/api/school';
import { TOrgList } from '@/types/views/school'

@Component({
  components: {
    Add: () => import('./components/add.vue'),
    Search: () => import('./components/search.vue')
  }
})
export default class Teacher extends Vue {
  private query = '';
  private layout: TLayout = layout
  private teacherPage: TTeacherPage = {
    list: [],
    totalPage: 0,
    totalQty: 0,
    currentPage: 1,
    pageSize: 20
  };
  private options = {
    orgId: '',
    name: '',
    currentPage: 1,
    size: 20
  }
  /**
   * 获取老师列表
   * @param {PTeacherList} params
   */
  private async getTeacherList(params: PTeacherList) {
    try {
      let res: any = await getTeacherList(params);
      this.teacherPage = res;
    } catch (e) {
      this.$message.error(e);
    }
  }

  private activated() {
    this.reload();
  }

  private handleSizeChange(size: number) {
    this.getTeacherList({
      currentPage: 1,
      size
    });
  }
  private handleCurrentChange(size: number) {
    this.getTeacherList({
      currentPage: size,
      size: this.teacherPage.pageSize
    });
  }
  /**
   * 渲染老师索引
   * 全部页数索引
   * @param {number} index
   * @returns {number} 索引值
   */

  private renderIndex(index: number) {
    return (
      index +
        1 +
        (this.teacherPage.currentPage - 1) * this.teacherPage.pageSize || 0
    );
  }
  /**
   * 查看老师详情
   * @param {number} id 老师Id
   */

  private goToDetail(id: number) {
    this.$router.push({
      path: `/school/teacher-detail/${id}`
    });
  }
  private search() {
    this.getTeacherList({
      currentPage: 1,
      size: 20,
      name: this.query
    });
  }
  private reload() {
    this.getTeacherList({
      currentPage: 1,
      size: 20,
      name: ''
    });
  }
  // add by_ALi
  /**
   * 查看老师详情
   * @param {TOrgList} params 老师Id
   */
  private handleOptions(params: TOrgList) {
    this.options = { ...this.options, ...params }
  }
  private getTeachersPage() {
    this.getTeacherList(this.options)
  }
}
